export enum ViewPort {
  mobile = 'mobile',
  tab = 'tab',
  desktop = 'desktop',
  desktopSmall = 'desktopSmall',
  desktopBig = 'desktopBig',
  tabSmall = 'tabSmall',
  tabBig = 'tabBig',
}

export const DESKTOP_VIEW_PORT = [ViewPort.desktop, ViewPort.desktopSmall, ViewPort.desktopBig];
export const TAB_VIEW_PORT = [ViewPort.tab, ViewPort.tabSmall, ViewPort.tabBig];
export const MOBILE_VIEW_PORT = [ViewPort.mobile];
